export default __webpack_public_path__ + "static/media/rede1.52452d41.png";